<template>
  <div class="obj-major-info-content config-info">
    <el-row type="flex" justify="space-between" class="title-bar">
      <div class="title">구성 정보</div>
      <div>
        <span class="collapse-detail-btn" @click="isOperActive = !isOperActive">
          {{ isOperActive ? '접기' : '더보기'}}
          <i :class="['far', isOperActive ? 'fa-angle-up' : 'fa-angle-down']"></i>
        </span>
      </div>
    </el-row>
    <div class="config-content-wrapper" v-show="!isOperActive">
      <table class="config-content">
        <tr v-for="oper in operationInfo" :key="oper.key">
          <th>{{ oper.label }}</th>
          <td v-if="oper.key === 'availRateValue'">
            <span class="oper-progress mr-r5">
              <el-progress :show-text="false" :stroke-width="10" :percentage="getStringtoNumber(configInfoData[oper.key])" color="#5372a5"></el-progress>
            </span>
            <span class="oper-value" @click="onClickAvailRatePopup">{{ `${getStringtoNumber(configInfoData[oper.key])} %` }}</span>
            <span class="sub-label">(최근12시간)</span>
          </td>
          <td class="value" v-else>
            <label :title="convertValue(configInfoData[oper.key], oper.key, isEmpty(oper.formatter) ? '' : oper.formatter)">
              {{ convertValue(configInfoData[oper.key], oper.key, isEmpty(oper.formatter) ? '' : oper.formatter) }}
            </label>
          </td>
        </tr>
      </table>
    </div>
    <div class="config-content-wrapper detail" v-show="isOperActive">
      <template v-if="objectInfo.objDefineId !== 'NETDEVICE' && objectInfo.objDefineId !== 'E2E_SERVICE' && objectInfo.objDefineId !== 'VMS_OBJECT'">
        <el-radio-group v-model="activeTab" class="ordinary">
          <el-radio-button label="basic">기본정보</el-radio-button>
          <el-radio-button v-for="detail in detailInfo" :key="detail.key" :label="detail.key"> {{ detail.title }}</el-radio-button>
        </el-radio-group>
        <table class="config-content" v-show="activeTab === 'basic'">
          <tr v-for="basic in basicInfo" :key="basic.key">
            <th>{{ basic.label }}</th>
            <td v-if="basic.key === 'availRateValue'">
              <span class="oper-progress mr-r5">
                <el-progress :show-text="false" :stroke-width="10" :percentage="getStringtoNumber(configInfoData[basic.key])" color="#5372a5"></el-progress>
              </span>
              <span class="oper-value">{{ `${getStringtoNumber(configInfoData[basic.key])} %` }}</span>
              <span class="sub-label">(최근12시간)</span>
            </td>
            <td class="value" v-else>
              <span>
                <label :title="convertValue(configInfoData[basic.key], basic.key, isEmpty(basic.formatter) ? '' : basic.formatter)">
                  {{ convertValue(configInfoData[basic.key], basic.key, isEmpty(basic.formatter) ? '' : basic.formatter) }}
                </label>
              </span>
              <li v-if="basic.subContent && subConfigContent(basic).length > 0" v-for="config in subConfigContent(basic)" :key="config.rsctypeId">
                {{ `${config.rsctypeName}: ${config.rscKeyCount} 개`}}
              </li>
            </td>
          </tr>
        </table>
        <div v-show="activeTab != 'basic'">
          <template v-if="objectInfo.objDefineId === 'SERVICE'">
            <el-table
              :data="configInfoData.deviceList"
              height="100%"
              style="width: 100%"
              class="popup"
              >
              <el-table-column
                v-for="column in detailInfo[0].contents"
                :key="column.prop"
                :prop="column.prop"
                :label="column.label"
                :width="column.width"
                :align="column.align"
                >
              </el-table-column>
            </el-table>
          </template>
          <template v-else>
            <table class="config-content" v-for="detail in detailInfo" :key="detail.key">
              <tr v-for="item in detailContents(detail.contents)" :key="item.key">
                <th>{{ item.label }}</th>
                <td class="value">
                  <label :title="convertValue(configInfoData[item.key], item.key, isEmpty(item.formatter) ? '' : item.formatter, isEmpty(item.unit) ? '' : item.unit, isEmpty(item.unitText) ? '' : item.unitText)">
                    {{ convertValue(configInfoData[item.key], item.key, isEmpty(item.formatter) ? '' : item.formatter, isEmpty(item.unit) ? '' : item.unit, isEmpty(item.unitText) ? '' : item.unitText) }}
                  </label>
                </td>
              </tr>
            </table>
          </template>
        </div>
      </template>
      <template v-if="objectInfo.objDefineId !== 'E2E_SERVICE' && objectInfo.objDefineId !== 'NETDEVICE' && objectInfo.objDefineId === 'VMS_OBJECT'">
        <el-radio-group v-model="activeTab" class="ordinary">
          <el-radio-button label="basic" v-if="basicInfo.length > 0">기본정보</el-radio-button>
          <el-radio-button v-for="detail in detailInfo" :key="detail.key" :label="detail.key"> {{ detail.title }}</el-radio-button>
        </el-radio-group>
        <table class="config-content" v-if="activeTab === 'basic'">
          <tr v-for="basic in basicInfo" :key="basic.key">
            <th>{{ basic.label }}</th>
            <td v-if="basic.key === 'availRateValue'">
              <span class="oper-progress mr-r5">
                <el-progress :show-text="false" :stroke-width="10" :percentage="getStringtoNumber(configInfoData[basic.key])" color="#5372a5"></el-progress>
              </span>
              <span class="oper-value">{{ `${getStringtoNumber(configInfoData[basic.key])} %` }}</span>
              <span class="sub-label">(최근12시간)</span>
            </td>
            <td class="value" v-else>
              <span>
                <label :title="convertValue(configInfoData[basic.key], basic.key, isEmpty(basic.formatter) ? '' : basic.formatter)">
                  {{ convertValue(configInfoData[basic.key], basic.key, isEmpty(basic.formatter) ? '' : basic.formatter) }}
                </label>
              </span>
              <li v-if="basic.subContent && subConfigContent(basic).length > 0" v-for="config in subConfigContent(basic)" :key="config.rsctypeId">
                {{ `${config.rsctypeName}: ${config.rscKeyCount} 개`}}
              </li>
            </td>
          </tr>
        </table>
        <div v-else-if="activeTab === 'hwswInfo'">
          <template>
            <table class="config-content">
              <tr v-for="item in detailContents(detailInfo[0].contents)" :key="item.key">
                <th class="label-long">{{ item.label }}</th>
                <td class="value">
                  <label :title="convertValue(configInfoData[item.key], item.key, isEmpty(item.formatter) ? '' : item.formatter, isEmpty(item.unit) ? '' : item.unit, isEmpty(item.unitText) ? '' : item.unitText)">
                    {{ convertValue(configInfoData[item.key], item.key, isEmpty(item.formatter) ? '' : item.formatter, isEmpty(item.unit) ? '' : item.unit, isEmpty(item.unitText) ? '' : item.unitText) }}
                  </label>
                </td>
              </tr>
            </table>
          </template>
        </div>
        <div v-else-if="activeTab === 'VMWARE'">
          <template>
            <table class="config-content">
              <tr v-for="item in detailContents(detailInfo[1].contents)" :key="item.key">
                <th>{{ item.label }}</th>
                <td class="value">
                  <label :title="convertValue(configInfoData[item.key], item.key, isEmpty(item.formatter) ? '' : item.formatter)">
                    {{ convertValue(configInfoData[item.key], item.key, isEmpty(item.formatter) ? '' : item.formatter) }}
                  </label>
                </td>
              </tr>
            </table>
          </template>
        </div>
      </template>
      <template v-else-if="objectInfo.objDefineId === 'NETDEVICE'">
        <el-radio-group v-model="activeTab" class="ordinary">
          <el-radio-button label="basic">기본정보</el-radio-button>
          <el-radio-button v-for="detail in detailInfo" :key="detail.key" :label="detail.key"> {{ detail.title }}</el-radio-button>
        </el-radio-group>
        <table class="config-content" v-show="activeTab === 'basic'">
          <tr v-for="basic in basicInfo" :key="basic.key">
            <th>{{ basic.label }}</th>
            <td v-if="basic.key === 'availRateValue'">
              <span class="oper-progress mr-r5">
                <el-progress :show-text="false" :stroke-width="10" :percentage="getStringtoNumber(configInfoData[basic.key])" color="#5372a5"></el-progress>
              </span>
              <span class="oper-value">{{ `${getStringtoNumber(configInfoData[basic.key])} %` }}</span>
              <span class="sub-label">(최근12시간)</span>
            </td>
            <td class="value" v-else>
              <span>
                <label :title="convertValue(configInfoData[basic.key], basic.key, isEmpty(basic.formatter) ? '' : basic.formatter)">
                  {{ convertValue(configInfoData[basic.key], basic.key, isEmpty(basic.formatter) ? '' : basic.formatter) }}
                </label>
              </span>
              <li v-if="basic.subContent && subConfigContent(basic).length > 0" v-for="config in subConfigContent(basic)" :key="config.rsctypeId">
                {{ `${config.rsctypeName}: ${config.rscKeyCount} 개`}}
              </li>
            </td>
          </tr>
        </table>
        <div v-show="activeTab === 'hwswInfo'">
          <table class="config-content">
          <!-- <table class="config-content" v-for="detail in detailInfo" :key="detail.key"> -->
            <tr v-for="item in detailContents(detailInfo[0].contents)" :key="item.key">
              <template v-if="showHwswInfo(item.enableKey)">
                <th class="label-long">{{ item.label }}</th>
                <td class="value">
                  <label :title="convertValue(configInfoData[item.key], item.key, isEmpty(item.formatter) ? '' : item.formatter, isEmpty(item.unit) ? '' : item.unit, isEmpty(item.unitText) ? '' : item.unitText)">
                    {{ convertValue(configInfoData[item.key], item.key, isEmpty(item.formatter) ? '' : item.formatter, isEmpty(item.unit) ? '' : item.unit, isEmpty(item.unitText) ? '' : item.unitText) }}
                  </label>
                </td>
              </template>
            </tr>
          </table>
        </div>
        <div v-if="customerId === customer.SKT && activeTab === 'Tiams'">
          <table class="config-content">
            <tr v-for="item in detailContents(detailInfo[1].contents)" :key="item.key">
              <template>
                <th class="label-long">{{ item.label }}</th>
                <td class="value">
                  <label :title="convertValue(configInfoData[item.key], item.key, isEmpty(item.formatter) ? '' : item.formatter, isEmpty(item.unit) ? '' : item.unit, isEmpty(item.unitText) ? '' : item.unitText)">
                    {{ convertValue(configInfoData[item.key], item.key, isEmpty(item.formatter) ? '' : item.formatter, isEmpty(item.unit) ? '' : item.unit, isEmpty(item.unitText) ? '' : item.unitText) }}
                  </label>
                </td>
              </template>
            </tr>
          </table>
        </div>
      </template>
      <template v-else-if="objectInfo.objDefineId === 'E2E_SERVICE'">
        <el-radio-group v-model="activeTab" class="ordinary">
          <el-radio-button label="basic">기본정보</el-radio-button>
          <el-radio-button v-for="detail in detailInfo" :key="detail.key" :label="detail.key"> {{ detail.title }}</el-radio-button>
        </el-radio-group>
        <table class="config-content" v-show="activeTab === 'basic'">
          <tr v-for="basic in basicInfo" :key="basic.key">
            <th>{{ basic.label }}</th>
            <td v-if="basic.key === 'availRateValue'">
              <span class="oper-progress mr-r5">
                <el-progress :show-text="false" :stroke-width="10" :percentage="getStringtoNumber(configInfoData[basic.key])" color="#5372a5"></el-progress>
              </span>
              <span class="oper-value">{{ `${getStringtoNumber(configInfoData[basic.key])} %` }}</span>
              <span class="sub-labell">(최근12시간)</span>
            </td>
            <td class="value" v-else>
              <span>
                <label :title="convertValue(configInfoData[basic.key], basic.key, isEmpty(basic.formatter) ? '' : basic.formatter)">
                  {{ convertValue(configInfoData[basic.key], basic.key, isEmpty(basic.formatter) ? '' : basic.formatter) }}
                </label>
              </span>
            </td>
          </tr>
        </table>
        <div v-show="activeTab === 'agent'">
          <table class="content e2e-service">
            <tr v-for="item in configInfoData.agentList" :key="item.key">
              <th>{{ item.agentName }}</th>
              <td class="value">{{ item.agentIpaddress }}</td>
            </tr>
          </table>
        </div>
        <div v-show="activeTab === 'protocol'">
          <table class="list-info-single e2e-protocol">
            <tr v-for="item in detailContents(detailInfo[1].contents[configInfoData.protocol])" :key="item.key">
              <th>{{ item.label }}</th>
              <td v-if="item.key === 'httpsCertificateUseFlag'">
                <span>
                  <el-checkbox disabled v-model="configInfoData[item.key]" :true-label="1" :false-label="0"></el-checkbox>
                </span>
              </td>
              <td class="value" v-else>
                <label :title="convertValue(configInfoData[item.key], item.key, isEmpty(item.formatter) ? '' : item.formatter)">
                  {{ convertValue(configInfoData[item.key], item.key, isEmpty(item.formatter) ? '' : item.formatter) }}
                </label>
              </td>
            </tr>
          </table>
        </div>
      </template>
    </div>
    <w-avail-rate-sliding-popup ref="availRateSlidingPopup" :obj-info="objInfo"></w-avail-rate-sliding-popup>
  </div>
</template>

<script>
import { isEmpty, cloneDeep, find, isNil, filter } from 'lodash';
import WAvailRateSlidingPopup from '@/views/performance/node/summary/components/AvailRateSlidingPopup';
import { OPERATION_INFO } from '@/constants/topologymap-major-info';
import { getDateToString, calcUptime } from '@/utils/date';
import { getValueAfterCheckEmpty, EMPTY_TEXT } from '@/utils/string';
import { convertValuByUnit } from '@/utils/number';
import { customer } from '@/constants/customer-define';
import { objtype } from '@/constants/objtype';
import { getRadioBandByChannel } from '@/utils/wireless-device';


export default {
  name: 'WManagedObjectBasicInfoView',
  components: {
    WAvailRateSlidingPopup,
  },
  props: {
    objectInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      getValueAfterCheckEmpty,
      isEmpty,
      customer,
      /**
       * 구성정보 표현 객체
       * @type {Object}
       */
      OPERATION_INFO,
      /**
       * 구성정보 데이터
       * @type {Object}
       */
      configInfoData: {},
      /**
       * 더보기 세부 탭
       * @type {String}
       */
      activeTab: 'basic',
      /**
       * 더보기 활성화 flag
       * @type {Boolean}
       */
      isOperActive: false,
    };
  },
  computed: {
    /**
     * 관리대상 정보 객체
     * @author JungJiyoon(ryunnnne)
     * @return {[type]} [description]
     */
    objInfo() {
      return {
        label: this.objectInfo.objName,
        obj: this.objectInfo,
      };
    },
    subConfigContent() {
      return (basic) => {
        let configCount = [];
        if (basic.subContent) {
          const findItem = find(this.configInfoData.configCount, (item) => item.elementType === basic.key);
          if (!isEmpty(findItem)) {
            configCount = findItem.rscKeyCount;
          }
        }
        return configCount;
      };
    },
    /**
     * 구성정보 표현 키 반환
     * @author JungJiyoon(ryunnnne)
     * @return {[type]} [description]
     */
    configKeys() {
      return Object.keys(this.configInfoData);
    },
    /**
     * 구성정보 더보기 이전 표현 객체
     * @author JungJiyoon(ryunnnne)
     * @return {[type]} [description]
     */
    operationInfo() {
      let oper = [{ key: '', label: '' }];
      if (!isEmpty(this.objectInfo)) {
        if (this.objectInfo.objDefineId === 'VMS_OBJECT' || this.objectInfo.objDefineId === 'WIRELESS_DEVICE') {
          oper = OPERATION_INFO[this.objectInfo.objDefineId][this.objectInfo.objtypeId].DEFAULT;
        } else {
          oper = OPERATION_INFO[this.objectInfo.objDefineId].DEFAULT || [];
        }
      }
      return oper;
    },
    /**
     * 구성정보 더보기 이후 기본정보 탭 표현 객체
     * @author JungJiyoon(ryunnnne)
     * @return {[type]} [description]
     */
    basicInfo() {
      let oper = [{ key: '', label: '' }];
      if (!isEmpty(this.objectInfo)) {
        if (this.objectInfo.objDefineId === 'VMS_OBJECT' || this.objectInfo.objDefineId === 'WIRELESS_DEVICE') {
          oper = OPERATION_INFO[this.objectInfo.objDefineId][this.objectInfo.objtypeId].BASIC || [];
          if (this.objectInfo.objtypeId === objtype.WIRELESS_AP && isNil(this.configInfoData.parentObjId)) {
            return filter(oper, (item) => item.key !== 'controller');
          }
        } else {
          oper = OPERATION_INFO[this.objectInfo.objDefineId].BASIC || [];
        }
      }
      return oper;
    },
    /**
     * 구성정보 더보기 이후 기본정보 제외한 다른 탭 표현 객체
     * @author JungJiyoon(ryunnnne)
     * @return {[type]} [description]
     */
    detailInfo() {
      let detail = [{ title: '', contents: [{ key: '', label: '' }] }];
      if (!isEmpty(this.objectInfo)) {
        if (this.objectInfo.objDefineId === 'VMS_OBJECT' || this.objectInfo.objDefineId === 'WIRELESS_DEVICE') {
          detail = OPERATION_INFO[this.objectInfo.objDefineId][this.objectInfo.objtypeId].DETAILS || [];
        } else if (this.objectInfo.objDefineId === 'NETDEVICE') {
          detail = (this.customerId === customer.SKT) ? OPERATION_INFO[this.objectInfo.objDefineId].DETAILS : [OPERATION_INFO[this.objectInfo.objDefineId].DETAILS[0]];
        } else {
          detail = OPERATION_INFO[this.objectInfo.objDefineId].DETAILS || [];
        }
      }
      return detail;
    },
    /**
     * 구성정보 더보기 이후 기본정보 제외한 다른 탭 내용
     * @author JungJiyoon(ryunnnne)
     * @return {[type]} [description]
     */
    detailContents() {
      return (contents) => {
        if (!isEmpty(this.objectInfo)) {
          if (this.objectInfo.objDefineId === 'DBMS') {
            return contents[this.detailInfoKey(this.objectInfo.objDefineId, this.objectInfo.objtypeId)];
          } else if (this.objectInfo.objDefineId === 'VMS_OBJECT') {
            if (this.objectInfo.objtypeId === 'VDSC') {
              return contents.COMMON;
            }
            return contents[this.detailInfoKey(this.objectInfo.objDefineId, this.configInfoData.basicinfoSubid)];
          }
        }
        return contents;
      };
    },
    /**
     * 구성정보 더보기 이후 기본정보 제외한 다른 탭 내용 구분 키값
     * @author JungJiyoon(ryunnnne)
     * @return {[type]} [description]
     */
    detailInfoKey() {
      return (objDefineId, type) => {
        {
          let typeKey = 'COMMON';
          if (type === 'CUBRID' || type === 'ORACLE') {
            typeKey = type;
          } else if (objDefineId === 'VMS_OBJECT') {
            typeKey = type;
          }
          return typeKey;
        }
      };
    },
    showHwswInfo() {
      return (enableKey) => {
        if (!isEmpty(enableKey)) {
          return this.customerId === customer.SKS;
        }
        return true;
      };
    },
    customerId() {
      return this.$store.state.common.customerId;
    },
  },
  methods: {
    /**
     * 더보기 활성화 변경 콜백
     * @author JungJiyoon(ryunnnne)
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    onOperActive(value) {
      this.isOperActive = !isEmpty(value);
    },
    /**
      * 데이터 초기화(요청데이터)
     * @author JungJiyoon(ryunnnne)
     * @param  {[type]} configInfoData [description]
     */
    setData(configInfoData) {
      const data = cloneDeep(configInfoData);
      delete data.eventInfo;
      delete data.perfInfo;
      this.configInfoData = data;
      this.activeTab = (this.objectInfo.objtypeId === 'VCL') ? 'hwswInfo' : 'basic';
    },
    /**
     * 데이터 초기화(기본값)
     * @author JungJiyoon(ryunnnne)
     * @return {[type]} [description]
     */
    initData() {
      this.configInfoData = {};
      this.activeTab = 'basic';
      this.isOperActive = false;
    },
    /**
     * 포매터 속은 key값에 따른 값 변환 함수
     * @author JungJiyoon(ryunnnne)
     * @param  {[type]} value     [description]
     * @param  {[type]} key       [description]
     * @param  {[type]} formatter [description]
     * @param  {[type]} unit      [description]
     * @param  {[type]} unitText  [description]
     * @return {[type]}           [description]
     */
    convertValue(value, key, formatter, unit, unitText) {
      // formatter 처리
      if (formatter === 'value') {
        let result = '';
        if (isNil(value) || (isEmpty(unit) && isEmpty(unitText))) {
          result = `${convertValuByUnit(value, '', true, null, true)}`;
        } else {
          result = `${convertValuByUnit(value, unit, true, false, true)}${isEmpty(unitText) ? '' : unitText}`;
        }
        return result;
      } else if (formatter === 'calcUptime') {
        return calcUptime(new Date(value), new Date());
      } else if (formatter === 'label') {
        if (key === 'netinterfaceSpeedUpdateFlag') {
          return (value === '1') ? '갱신 중' : getValueAfterCheckEmpty(value);
        } else if (key === 'netinterfaceStatusOper' || key === 'netinterfaceStatusAdmin') {
          return (value === 1) ? 'UP' : 'DOWN';
        }
      } else if (formatter === 'httpAdjustTypeSummary') {
        let label = '';
        if (value === 'N') {
          label = '사용안함';
        } else if (value === 'G') {
          label = `${this.configInfoData.httpAdjustText} (포함)`;
        } else if (value === 'B') {
          label = `${this.configInfoData.httpAdjustText} (제외)`;
        }
        return label;
      } else if (formatter === 'httpAdjustTypeDetail') {
        let label = '';
        if (value === 'N') {
          label = '사용안함';
        } else if (value === 'G') {
          label = '해당 문자열이 있어야함';
        } else if (value === 'B') {
          label = '해당 문자열이 있으면 안됨';
        }
        return label;
      } else if (formatter === 'vhoCpuCoreFormat') {
        const data = this.configInfoData;
        return `${data['VHO_COMMON/CPU_CORE_TOTAL_COUNT']}개, CPU*${convertValuByUnit(Number(data['VHO_COMMON/CPU_CLOCK']), 'MB', true, false, true)}hz`;
      } else if (formatter === 'vvmCpuCoreFormat') {
        const data = this.configInfoData;
        return `${data['VVM_COMMON/CPU_CORE_TOTAL_COUNT']}개, CPU*${convertValuByUnit(Number(data['VVM_COMMON/CPU_CLOCK']), 'MB', true, false, true)}hz`;
      } else if (formatter === 'count') {
        return `${isNil(value) ? 0 : value}개`;
      } else if (formatter === 'day') {
        return !isNil(value) ? `${value}일` : EMPTY_TEXT;
      } else if (formatter === 'datetime') {
        return value ? getDateToString(value) : '-';
      } else if (formatter === 'password') {
        let str = '';
        if (!isEmpty(value)) {
          for (let i = 0; i < value.length; i += 1) {
            str += '*';
          }
        } else {
          str = '-';
        }
        return str;
      } else if (formatter === 'periodVhoBootTime') {
        const data = this.configInfoData;
        return `${data['VHO_COMMON/BOOT_TIME']} (${calcUptime(new Date(data['VHO_COMMON/BOOT_TIME']), new Date())})`;
      } else if (formatter === 'periodVvmBootTime') {
        const data = this.configInfoData;
        return `${data['VVM_COMMON/BOOT_TIME']} (${calcUptime(new Date(data['VVM_COMMON/BOOT_TIME']), new Date())})`;
      } else if (formatter === 'radioBandChannelLabel') {
        const data = this.configInfoData;
        return !isEmpty(data.channel) ? getRadioBandByChannel(data.channel, true) : getValueAfterCheckEmpty(data.radioBand);
      }

      // key 값에 다른 값 변환 처리
      if (key === 'adminInfoLabel') {
        return `${getValueAfterCheckEmpty(this.configInfoData.objManagerIdMajor)} / ${getValueAfterCheckEmpty(this.configInfoData.objManagerIdMinor)}`;
      } else if (key === 'dbmsServiceLabel') {
        return `${getValueAfterCheckEmpty(this.configInfoData.dbmsService)} / ${getValueAfterCheckEmpty(this.configInfoData.dbmsAlias)}`;
      }
      return getValueAfterCheckEmpty(value);
    },
    /**
     * String > Number 변환
     * @author JungJiyoon(ryunnnne)
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    getStringtoNumber(value) {
      return value > 0 ? Number(value) : 0;
    },
    /**
     * 가동률 값 클릭 시 슬라이딩 팝업 오픈
     * @author JungJiyoon(ryunnnne)
     * @return {[type]} [description]
     */
    onClickAvailRatePopup() {
      this.$refs.availRateSlidingPopup.open();
    },
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/major-info/ManagedObjectBasicInfoView.vue